import { render, staticRenderFns } from "./RestoreProjectForm.vue?vue&type=template&id=2dcc97c6"
import script from "./RestoreProjectForm.vue?vue&type=script&lang=js"
export * from "./RestoreProjectForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports